<!--
component: Menu
author: Ken Nakamura
description: メインメニュー画面
-->
<template>
  <section class="menu">
      <div class="head-message">
        閲覧対象を選択してください
      </div>
      <section class="ges-contents py-3 text-center container-fluid">
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" lg="4" class="py-3" v-show="menuVisible(1)">
            <div class="ges-button ges-button-building" @click="gotoKenkaku">
              建築物
            </div>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" lg="4" class="py-3" v-show="menuVisible(8)">
            <div class="ges-button ges-button-kousaku" @click="gotoKousakubutsu">
              工作物
            </div>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" lg="4" class="py-3" v-show="menuVisible(2)">
            <div class="ges-button ges-button-elevator" @click="gotoElevator">
              昇降機
            </div>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" lg="4" class="py-3" v-show="menuVisible(3)">
            <div class="ges-button ges-button-report-disabled" @click="openTeihoGuideDialog">
              定期<br>報告
            </div>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" lg="4" class="py-3" v-show="menuVisible(5)">
            
            <div class="ges-button ges-button-kaihatsu" @click="gotoKaihatsu">
              <!-- 旧：開発・宅造 フォルダ名などの変更はバッチファイルなどの不具合が予想されるため保留 -->
              開発・造成<br>土石の堆積
            </div>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" lg="4" class="py-3" v-show="menuVisible(4)">
            <div class="ges-button ges-button-sproad" @click="gotoSpecRoad">
              位置指定<br>道路図
            </div>
          </v-col>
          <!--
          <div class="col-sm-4 py-3">
            <div class="ges-button ges-button-takuzo" @click="gotoTakuzo">
              宅造
            </div>
          </div>
          -->
          <v-col cols="12" xs="12" sm="6" md="4" lg="4" class="py-3" v-show="menuVisible(7)">
            <div class="ges-button ges-button-kyoai" @click="gotoKyoai">
              狭あい道路<br>実測図
            </div>
          </v-col>
        </v-row>
        <v-dialog v-model="teihoGuideDialog" max-width="640" content-class="teiho-guide-dialog">
          <v-card class="teiho-guide-card">
            <v-card-title class="teiho-guide-title">
              ご案内
              <v-btn
                icon
                color="primary"
                class="teiho-guide-close-btn"
                @click="closeTeihoGuideDialog"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="teiho-guide-body">
              <p class="teiho-guide-message">
                本機能は「横浜市定期報告オンラインシステム」に移行しました。
              </p>
              <p class="teiho-guide-notice">
                詳細はこちら
                <a
                  href="https://hamayamori.city.yokohama.lg.jp/teikihoukoku/"
                  target="_blank"
                  rel="noopener noreferrer"
                >https://hamayamori.city.yokohama.lg.jp/teikihoukoku/</a>
              </p>
            </v-card-text>
            <v-card-actions class="px-6 pb-4 teiho-guide-actions">
              <v-btn
                color="primary"
                class="teiho-guide-open-btn"
                @click="openTeihoNewSystem"
              >
                横浜市定期報告<br/>オンラインシステム<br/>を開く
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </section>
  </section>
</template>

<script>
import { dbglog } from '../common/utils.js'

const MENU_NOTICE_READ_KEY_PREFIX = 'ykh-ges-menu-notice-read:'
const MENU_NOTICE_HTML_PATH = 'notices/notice_menu.html'
const MENU_NOTICE_TARGET_AUTHORITIES = [0, 5]

const TEMP_DISABLE_MENU_AUTH = true;
const TEIHO_NEW_SYSTEM_URL = 'https://hamayamori.city.yokohama.lg.jp/teikihoukoku/';

export default {
  data () {
    return {
      teihoGuideDialog: false,
    }
  },
  watch: {
    /**
     * 周知本文の読込完了後に、自動表示対象かどうかを再判定する。
     */
    menuNoticeHtml() {
      this.showMenuNoticeIfNeeded();
    },
  },
  mounted () {
    this.mode = 0;
    this.$store.commit('setCurrentPage', 1);
    dbglog(`Menu.mounted: ${this.token}`, 1);
    if (this.unauthorized && !this.menuPreviewEnabled) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
    }
    else {
      this.message = '閲覧対象を選択してください';
      this.showMenuNoticeIfNeeded();
    }
  },
  computed: {
    mode: {
      get() { return this.$store.state.mode; },
      set(val) { this.$store.commit('setMode', val); }
    },
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    userInfo () {
      return this.$store.state.userInfo;
    },
    menuNoticeHtml () {
      return this.$store.state.menuNoticeHtml;
    },
    menuPreviewEnabled () {
      if (TEMP_DISABLE_MENU_AUTH) {
        return true;
      }
      const previewQuery = this.$route?.query?.preview;
      const previewByQuery = previewQuery === '1' || previewQuery === 'true';
      const previewByStorage = window.localStorage.getItem('menu_preview') === '1';
      return previewByQuery || previewByStorage;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    }
  },
  methods: {
    /**
     * 一般利用者向けの既読状態を保持するlocalStorageキーを返す。
     *
     * @returns {string} 周知既読判定用キー
     */
    menuNoticeReadKey() {
      const today = new Date().toLocaleDateString('sv-SE');
      return `${MENU_NOTICE_READ_KEY_PREFIX}${MENU_NOTICE_HTML_PATH}:${today}`;
    },
    /**
     * 周知本文が存在し、かつ対象権限の利用者かどうかを判定する。
     *
     * @returns {boolean} 自動表示判定の前提条件を満たす場合はtrue
     */
    canShowMenuNotice() {
      const authority = Number(this.userInfo?.authority);
      return !!this.menuNoticeHtml?.trim()
        && MENU_NOTICE_TARGET_AUTHORITIES.includes(authority);
    },
    /**
     * 周知ポップアップを自動表示する。
     * authority=5 はMenu到達ごと、authority=0 は未読時のみ表示する。
     */
    showMenuNoticeIfNeeded() {
      if (!this.canShowMenuNotice()) {
        return;
      }
      const authority = Number(this.userInfo?.authority);
      if (authority === 5) {
        this.$store.commit('setMenuNoticeDialogOpen', true);
        return;
      }
      if (authority === 0 && !localStorage.getItem(this.menuNoticeReadKey())) {
        this.$store.commit('setMenuNoticeDialogOpen', true);
      }
    },
    menuVisible(menuId) {
      return this.$store.state.menuFlag & (0x01 << (menuId - 1));
    },
    gotoKenkaku () {
      this.mode = 1;
      this.$router.push('method');
    },
    gotoElevator () {
      this.mode = 2;
      this.$store.commit('setSearchMode', 0);
      this.$router.push('wards');
    },
    gotoReport () {
      this.mode = 3;
      this.$store.commit('setSearchMode', 0);
      this.$router.push('wards');
    },
    openTeihoGuideDialog () {
      this.teihoGuideDialog = true;
    },
    closeTeihoGuideDialog () {
      this.teihoGuideDialog = false;
    },
    openTeihoNewSystem () {
      const newWindow = window.open(TEIHO_NEW_SYSTEM_URL, '_blank', 'noopener');
      if (!newWindow) {
        window.location.href = TEIHO_NEW_SYSTEM_URL;
      }
      this.closeTeihoGuideDialog();
    },
    gotoSpecRoad () {
      this.mode = 4;
      this.$router.push('method');
    },
    gotoKaihatsu () {
      this.mode = 5;
      this.$router.push('method');
    },
    gotoTakuzo () {
      this.mode = 6;
      this.$router.push('method');
    },
    gotoKyoai () {
      this.mode = 7;
      this.$router.push('method');
    },
    gotoKousakubutsu () {
      this.mode = 8;
//      this.$router.push('kousakuwards');
      this.$store.commit('setSearchMode', 0);
      this.$router.push('wards');
    },
    logout () {
      this.mode = 0;
      this.$router.push('login');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/common/common.css";
/*
.ges-contents {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
*/
.ges-button {
  font-size: calc(1.1rem + 3.0vw);
}
.ges-button-building {
  background: linear-gradient(#336688, #77aacc);
  color: #ddccee;
  padding: 1.0em 0.2em;
  margin: 0.2em;
}
.ges-button-elevator {
  background: linear-gradient(#552244, #885577);
  color: #ddccee;
  padding: 1.0em 0.2em;
  margin: 0.2em;
}
.ges-button-report {
  background: linear-gradient(#447733, #77aa66);
  color: #ddccee;
  padding: 0.28em 0.2em;
  margin: 0.2em;
}
.ges-button-report-disabled {
  background: linear-gradient(#6f6f6f, #9a9a9a);
  color: #f2f2f2;
  padding: 0.28em 0.2em;
  margin: 0.2em;
  filter: grayscale(0.6);
}
.ges-button-sproad {
  background: linear-gradient(#337768, #66aa9b);
  color: #ddccee;
  padding: 0.28em 0.2em;
  margin: 0.2em;
}
.ges-button-kaihatsu {
  background: linear-gradient(#51521d, #bac064);
  color: #ddccee;
  padding: 0.28em 0.2em;
  margin: 0.2em;
}
.ges-button-takuzo {
  background: linear-gradient(#392980, #7763c0);
  color: #ddccee;
  padding: 1.0em 0.2em;
  margin: 0.2em;
}
.ges-button-kyoai {
  background: linear-gradient(#392980, #7763c0);
  color: #ddccee;
  padding: 0.28em 0.2em;
  margin: 0.2em;
}

.ges-button-kousaku {
  background: linear-gradient(#805a29, #c09063);
  color: #ddccee;
  padding: 1.0em 0.2em;
  margin: 0.2em;
}

/* v-dialog の余白調整（Vuetify の .v-dialog を上書き） */
::v-deep .teiho-guide-dialog.v-dialog,
::v-deep .teiho-guide-dialog .v-dialog {
  margin-top: 24px;
  margin-bottom: 24px;
  padding-top: unset;
  padding-bottom: unset;
}

.teiho-guide-card {
  position: relative;
  padding: 12px;
}

/* ::v-deep で Vuetify 子要素にスタイルを確実に適用 */
.teiho-guide-card ::v-deep .v-card__title.teiho-guide-title {
  font-weight: 700;
  text-align: center;
  vertical-align: middle;
  flex-direction: column;
  flex-wrap: nowrap;
}

.teiho-guide-close-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

.teiho-guide-card ::v-deep .v-card__text.teiho-guide-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  gap: 0;
}

.teiho-guide-card ::v-deep .v-card__actions.teiho-guide-actions {
  justify-content: center;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
}

.teiho-guide-card ::v-deep .teiho-guide-open-btn {
  width: 320px;
  min-height: auto;
  height: auto;
  padding: 12px;
  white-space: normal;
}

.teiho-guide-card ::v-deep .teiho-guide-open-btn .v-btn__content {
  width: 100%;
  max-width: 100%;
  white-space: normal;
  font-size: 19px;
  text-align: center;
  display: block;
  line-height: 1.4;
}

.teiho-guide-card ::v-deep .teiho-guide-open-btn.v-btn--disabled {
  color: rgba(0, 0, 0, 0.54);
}

.teiho-guide-card ::v-deep .teiho-guide-message {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #b91c1c;
}

.teiho-guide-card ::v-deep .teiho-guide-notice {
  white-space: pre-line;
  margin-bottom: 0;
  font-size: 0.8rem;
  line-height: 1.6;
  text-align: center;
  vertical-align: middle;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.teiho-guide-card ::v-deep .teiho-guide-notice a {
  font-size: 0.8rem;
  word-break: break-all;
}

.teiho-guide-card ::v-deep .teiho-guide-url-placeholder {
  margin-top: 0.7rem;
  margin-bottom: 0;
  color: #b91c1c;
  font-size: 12px;
  text-align: center;
  flex-basis: 100%;
  display: flex;
  flex-direction: column;
  line-height: 16px;
}

</style>
